import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/Public/Auth/Login";
import Signup from "../pages/Public/Auth/Signup";
import AdminDashboard from "../pages/AdminPages/AdminDashboard";
import UserDashboard from "../pages/User/UserDashboard";
import UserDashboardTwo from "../pages/Guest/UserDashboardTwo";
import VerifiPage from "../pages/Public/Auth/VerifiPage";
import ReactivateAccount from "../pages/Public/Auth/ReactivateAccount";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import Home from "../pages/Public/Home/Home";
import { useAuth } from "../context/AuthContext";
import AboutTheApp from "../pages/Public/Home/AboutTheApp";
import ContactUsPage from "../pages/Public/Home/ContactUsPage";

// 🆕 استيراد الـ Layouts
import AdminLayout from "../layout/AdminLayout/AdminLayout";
import UserLayout from "../layout/UserLayout/UserLayout";
import GuestLayout from "../layout/GuestLayout/GuestLayout";
import PublicLayout from "../layout/PublicLayout/PublicLayout";
// الادارة
import Plans from "../pages/AdminPages/planspage/plansPageMain";
import Customers from "../pages/AdminPages/CustomerPage/CustomersHaveVersion/CustomerPageMain";
import Subscriptions from "../pages/AdminPages/Subscriptionspage/AllSubscriptionsPage";
import TechnicalSupport from "../pages/AdminPages/TechnicalSupportPage/TechnicalSupportPageMain";
import Settings from "../pages/AdminPages/Settingspage/SettingspageMain";
import Users from "../pages/AdminPages/Userspage/UserspageMain";
import VersionsPage from "../pages/AdminPages/Versions/VersionsPageMain";
import Backup from "../pages/AdminPages/Backuppage/BackupMain";
import WebsiteDashboardPage from "../pages/AdminPages/WebsiteDashboard/WebsiteDashboardPage";
import ReportsPage from "../pages/AdminPages/ReportsPage/ReportsPage";
import BrokerMainpage from "../pages/AdminPages/BrokersPage/BrokerMainpage";
import ContactFormpage from "../pages/AdminPages/ContactPage/ContactFormpage";

// صفحة العميل
import MyBouquetsPage from "../pages/User/Mybouquets/MyBouquetsPage";
import PackagesPage from "../pages/User/PackagesPage/PackagesPage";
import TechnicalSupportPage from "../pages/User/TechnicalSupportPage/TechnicalSupportPage";

// 🆕 استيراد تخطيط و صفحة البروكر
import BrokerLayout from "../layout/BrokerLayout/BrokerLayout";
import BrokerDashboardPage from "../pages/BrokerDashboard/BrokerDashboardPage/BrokerDashboardPage";
import NewRequestsPage from "../pages/BrokerDashboard/NewRequestsPage/NewRequestsPage";
import AllVerionspage from "../pages/BrokerDashboard/AllVersionsPage/AllVerionspage";
import CustomerAccountsPage from "../pages/BrokerDashboard/CustomerAccountsPage/CustomerAccountsPage";
import BrokerPlanesPage from "../pages/BrokerDashboard/BrokerPlanesPage";

const AppRoutes = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      {/* لو المستخدم مش عامل تسجيل دخول */}
      {!user ? (
        <>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
          </Route>

          <Route element={<PublicLayout />}>
            <Route path="/about-app" element={<AboutTheApp />} />
          </Route>
          <Route element={<PublicLayout/>}>
            <Route path="/contact-us" element={<ContactUsPage/>}/>
          </Route>

          <Route path="login" element={<Login />} />
          <Route path="signup" element={<Signup />} />
          <Route path="verifi-page" element={<VerifiPage />} />
          <Route path="reactivate-account" element={<ReactivateAccount />} />
          <Route path="*" element={<Navigate to="/login" replace />} />

          <Route element={<GuestLayout />}></Route>
        </>
      ) : (
        <>
          {/* منع الوصول لـ login/signup بعد تسجيل الدخول */}
          <Route path="login" element={<Navigate to="/" replace />} />
          <Route path="signup" element={<Navigate to="/" replace />} />

          {/* لو المستخدم مش مفعل */}
          {user.active === 0 ? (
            <Route
              path="*"
              element={<Navigate to="/reactivate-account" replace />}
            />
          ) : (
            <>
              {/* الإدارة */}
              {(user.type === "1" || user.type === "IgRANDaDMIN1344@$") && (
                <Route element={<AdminLayout />}>
                  {/* 👇 relative path */}
                  <Route
                    path="/"
                    element={<Navigate to="/admin/subscriptions" replace />}
                  />
                  <Route
                    path="*"
                    element={<Navigate to="/admin/subscriptions" replace />}
                  />
                  <Route path="/admin/plans" element={<Plans />} />
                  <Route path="/admin/customers" element={<Customers />} />
                  <Route
                    path="/admin/subscriptions"
                    element={<Subscriptions />}
                  />
                  <Route path="/admin/versions" element={<VersionsPage />} />
                  <Route path="/admin/brokers" element={<BrokerMainpage />} />
                  <Route path="/admin/backup" element={<Backup />} />
                  <Route path="/admin/support" element={<TechnicalSupport />} />
                  <Route
                    path="/admin/websitedashboard"
                    element={<WebsiteDashboardPage />}
                  />

                  <Route path="/admin/settings" element={<Settings />} />
                  <Route path="/admin/reports" element={<ReportsPage />} />

                  <Route path="/admin/users" element={<Users />} />
                  <Route path="/admin/contact-requests" element={<ContactFormpage />} />
                </Route>
              )}

              {/* المشترك */}
              {user.type === "client" && user.status === 1 && (
                <Route element={<UserLayout />}>
                  <Route path="user-dashboard" element={<UserDashboard />} />
                  <Route
                    path="/"
                    element={<Navigate to="/user-dashboard" replace />}
                  />
                  <Route
                    path="*"
                    element={<Navigate to="/user-dashboard" replace />}
                  />
                  <Route path="/user-profile" element={<MyBouquetsPage />} />
                  <Route path="/user-Packages" element={<PackagesPage />} />
                  <Route path="/user-mytickets" element={<TechnicalSupportPage />} />

                </Route>
              )}

              {/* غير المشترك */}
              {user.type === "user" && user.status === 0 && (
                <Route element={<GuestLayout />}>
                  <Route
                    path="user-dashboard-two"
                    element={<UserDashboardTwo />}
                  />
                  <Route
                    path="/"
                    element={<Navigate to="/user-dashboard-two" replace />}
                  />
                  <Route
                    path="*"
                    element={<Navigate to="/user-dashboard-two" replace />}
                  />
                </Route>
              )}

              {/* ✅ صفحات عامة حتى بعد تسجيل الدخول */}
              <Route
                path="verifi-page"
                element={
                  <PublicRoute>
                    <VerifiPage />
                  </PublicRoute>
                }
              />
              <Route
                path="reactivate-account"
                element={
                  <PublicRoute>
                    <ReactivateAccount />
                  </PublicRoute>
                }
              />

              {/* 🆕 بروكر */}
              {user.type === "broker" && user.status === 0 && (
                <Route element={<BrokerLayout />}>
                  <Route path="broker-dashboard" element={<BrokerDashboardPage />} />
                  <Route
                    path="/"
                    element={<Navigate to="/broker-dashboard" replace />}
                  />
                  <Route
                    path="*"
                    element={<Navigate to="/broker-dashboard" replace />}
                  />
                  <Route path="broker-new-requests" element={<NewRequestsPage />} />
                  <Route path="broker-all-versions" element={<AllVerionspage />} />
                  <Route path="broker-customer-accounts" element={<CustomerAccountsPage />} />
                  <Route path="broker-planes" element={<BrokerPlanesPage />} />
                </Route>
              )}
            </>
          )}
        </>
      )}
    </Routes>
  );
};

export default AppRoutes;
